// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root___KCUr","header":"ClearentDisclaimer_header__34S-e","inner":"ClearentDisclaimer_inner__3Ad89"};